import React, { useEffect, useRef, useState } from 'react';
import Button from './Button';
import './Carousel.css';
import './universal.css';

export default function Carousel({ slides = [], interval = 5000 }) {
  const [index, setIndex] = useState(0);
  const timer = useRef(null);

  useEffect(() => {
    if (slides.length <= 1) return;
    timer.current = setTimeout(() => setIndex((index + 1) % slides.length), interval);
    return () => clearTimeout(timer.current);
  }, [index, slides.length, interval]);

  const go = (i) => {
    clearTimeout(timer.current);
    setIndex((i + slides.length) % slides.length);
  };

  return (
    <div className="carousel">
      <div className="carousel-inner">
        {slides.map((s, i) => (
          <div
            key={i}
            className={`carousel-item ${i === index ? 'active' : ''}`}
            style={{ backgroundImage: `url(${s.image})` }}
          >
            <div className="carousel-overlay">
              {s.title && <h3>{s.title}</h3>}
              {s.subtitle && <p>{s.subtitle}</p>}
              {s.buttonText && (
                <div style={{ marginTop: 12 }}>
                  <Button to={s.buttonLink || '#'} className='uni-btn'>
                    {s.buttonText}
                  </Button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {slides.length > 1 && (
        <>
          <div className="carousel-controls">
            <button className="carousel-prev" onClick={() => go(index - 1)} aria-label="Previous">‹</button>
            <button className="carousel-next" onClick={() => go(index + 1)} aria-label="Next">›</button>
          </div>

          {/* <div className="carousel-indicators">
            {slides.map((_, i) => (
              <button key={i} className={i === index ? 'active' : ''} onClick={() => go(i)} aria-label={`Go to slide ${i+1}`} />
            ))}
          </div> */}
        </>
      )}
    </div>
  );
}
